// /practice/select の URL パラメータ（短縮形 career / job）と
// POST /api/v1/answers の API パラメータ（フルネーム selected_career_stage / selected_job_type）の単一ソース。

export const URL_TO_API_FILTER = {
  career: "selected_career_stage",
  job: "selected_job_type",
} as const;

export type FilterUrlKey = keyof typeof URL_TO_API_FILTER;

interface SearchParamsLike {
  get: (key: string) => string | null;
}

/** URL の searchParams から API 送信用ペイロードを作る。"all" や空は除外する */
export function buildFilterPayload(
  searchParams: SearchParamsLike
): Record<string, string> {
  const payload: Record<string, string> = {};
  for (const [urlKey, apiKey] of Object.entries(URL_TO_API_FILTER)) {
    const v = searchParams.get(urlKey);
    if (v && v !== "all") {
      payload[apiKey] = v;
    }
  }
  return payload;
}

interface BuildPracticeUrlArgs {
  questionId: number;
  career: string;
  job: string;
}

/** /practice/select → /practice の遷移 URL を生成する。"all" の軸はクエリから省略する */
export function buildPracticeUrl({ questionId, career, job }: BuildPracticeUrlArgs): string {
  const params = new URLSearchParams();
  params.set("questionId", String(questionId));
  if (career && career !== "all") params.set("career", career);
  if (job && job !== "all") params.set("job", job);
  return `/practice?${params.toString()}`;
}
